<template>
  <Record
    class="RecordArticleImport"
    :title="article.topic">
    <Row v-if="article.remoteArticleId">
      <Column :xl="3" :xs="6">
        <Set icon="site" :label="$t('site')">
          {{ site.name | fallback }}
        </Set>
      </Column>
      <Column :xl="3" :xs="6">
        <Set icon="link" :label="$t('associatedWith')">
          {{ article.slug | fallback }}
          <Btn class="ib xs danger light" @click="dissociate">
            <Icon name="cross" />
          </Btn>
        </Set>
      </Column>
    </Row>
    <div v-else>
      <Field
        :disabled="isFetchingRemoteArticles"
        :options="siteOptions"
        :placeholder="$t('associateSite')"
        type="select"
        :value.sync="siteId"
        @update:value="setSite" />
      <Loader
        v-if="isFetchingRemoteArticles"
        class="sm" />
      <MultiSelect
        v-if="areRemoteArticlesShown"
        :fieldLabel="$t('associateArticle')"
        :multiple="false"
        :options="remoteArticlesOptions"
        @update:value="associateRemoteArticle" />
    </div>
  </Record>
</template>

<script>
import { actions, getters } from '@utils'
import { pick, propEq } from 'rambda'
import MultiSelect from '@components/fields/MultiSelect'

export default {
  components: { MultiSelect },
  props: {
    article: Object,
    getRemoteArticles: Function,
  },
  data() {
    return {
      areRemoteArticlesShown: false,
      isAssociating: false,
      isFetchingRemoteArticles: false,
      remoteArticles: [],
      siteId: null,
    }
  },
  computed: {
    site() {
      if (!this.article.siteId) return

      return this
        .queryOne('site', this.article.siteId)
    },
    siteOptions() {
      return this
        .query('site')
        .map(site => [
          site.id,
          site.name,
        ])
    },
    remoteArticlesOptions() {
      return this
        .remoteArticles
        .map(remoteArticle => [
          remoteArticle.id,
          remoteArticle.title,
        ])
    },
    ...getters(),
  },
  methods: {
    async associateRemoteArticle(remoteArticleId) {
      const remoteArticle = this
        .remoteArticles
        .find(propEq('id', remoteArticleId))

      await this.$wrap(
        this.PATCH_ARTICLE({
          id: this.article.id,
          remoteArticleId,
          ...pick([
            'siteId',
            'slug',
            'url',
          ], remoteArticle),
        }),
        'isAssociating',
        this.$t('associated'),
      )

      this.areRemoteArticlesShown = false
    },
    async dissociate() {
      await this.PATCH_ARTICLE({
        id: this.article.id,
        remoteArticleId: null,
        slug: null,
        url: null,
      })
    },
    async setSite(siteId) {
      this.remoteArticles = await this.$wrap(
        this.getRemoteArticles(siteId),
        'isFetchingRemoteArticles',
      )

      this.areRemoteArticlesShown = true
    },
    ...actions('PATCH_ARTICLE'),
  },
}
</script>

<style lang="scss">
.RecordArticleImport {
  overflow: initial;
}
</style>

<i18n>
{
  "en": {
    "associate": "Associate",
    "associateArticle": "Associate article",
    "associateSite": "Associate site",
    "associated": "Associated",
    "associatedWith": "Associated with",
    "dissociate": "Dissociate",
    "site": "Site"
  }
}
</i18n>
